<template>
  <div class="big">
    <div class="page_title">用户拉新记录</div>
    <div style="padding:20px;">
      <div class="container">
        <div class="filterBox flex wrap">
          <div class="box flex">
            <div class="label">用户昵称(邀请人)</div>
            <el-input
              v-model="nick_name"
              style="width:130px"
              @change="search(0)"
            />
          </div>
          <div class="box flex">
            <div class="label">手机号(邀请人)</div>
            <el-input
              v-model="phone"
              style="width:130px"
              @change="search(0)"
            />
          </div>
          <div class="box flex">
            <div class="label">用户昵称(被邀请)</div>
            <el-input
              v-model="cover_nick_name"
              style="width:130px"
              @change="search(0)"
            />
          </div>
          <div class="box flex">
            <div class="label">手机号(被邀请)</div>
            <el-input
              v-model="cover_phone"
              style="width:130px"
              @change="search(0)"
            />
          </div>
          <div class="box flex">
            <div class="label">员工号</div>
            <el-input
              v-model="recommender_code"
              style="width:130px"
              @change="search(0)"
            />
          </div>
          <div class="box flex">
            <div class="label">员工姓名</div>
            <el-input
              v-model="recommender_name"
              style="width:130px"
              @change="search(0)"
            />
            <el-button
              type="info"
              class="search-button"
              @click="search(0)"
            >查询</el-button>
          </div>

        </div>
        <div class="filterBox flex wrap">
          <div
            class="box flex"
            style="align-items:center"
          >
            <span style="margin-right:10px">是否员工</span>
            <span>
              <el-radio-group
                v-model="is_staff"
                @change="search(0)"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </span>
          </div>
          <div
            class="box flex"
            style="align-items:center"
          >
            <span style="margin-right:10px">是否有效邀请</span>
            <span>
              <el-radio-group
                v-model="is_effective"
                @change="search(0)"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </span>
          </div>

        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1200px;"
            :header-cell-style="{background:'#F5F5F5'}"
            :span-method="objectSpanMethod"
          >
            <el-table-column
              prop="nick_name"
              label="用户昵称（邀请人）"
            />
            <el-table-column
              prop="phone"
              label="手机号（邀请人）"
            />
            <el-table-column
              prop="recommender_code"
              label="员工号"
            />
            <el-table-column
              prop="recommender_name"
              label="员工姓名"
            />
            <el-table-column
              label="用户昵称（被邀请）"
              prop="nick_name_m"
              class-name="border-column"
              align="center"
            />
            <el-table-column
              label="手机号（被邀请）"
              align="center"
              class-name="border-column"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.phone_m!='查看更多'">{{scope.row.phone_m}}</span>
                <span
                  class="main-color"
                  style="cursor:pointer"
                  v-if="scope.row.phone_m=='查看更多'"
                  @click="showMore(scope.row.user_id)"
                >查看更多</span>
              </template>
            </el-table-column>
            <el-table-column
              label="是否登录APP"
              align="center"
              class-name="border-column"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.item_id>0">是</span>
              </template>
            </el-table-column>
            <el-table-column
              label="是否登录小程序"
              align="center"
              class-name="border-column"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.openid">是</span>
              </template>
            </el-table-column>
            <el-table-column
              label="是否有效邀请"
              align="center"
              class-name="border-column"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.is_effective==1">是</span>
                <span v-if="scope.row.is_effective==0">否</span>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              class-name="border-column"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toEditLog(scope.row.user_id)"
                  :disabled="module_id_array[0]?!module_id_array.includes('869'):false"
                >编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 更多邀请人弹窗 -->
    <el-dialog
      title="更多被邀请人"
      :visible.sync="extraShow"
      width="700px"
      style="text-align:left"
      center
    >
      <div style="padding:20px">
        <div style="margin-bottom:15px">
          <span style="margin-right:6px">是否有效邀请</span>
          <span>
            <el-radio-group
              v-model="is_effective_m"
              @change="search(1)"
            >
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </span>
          <span style="margin:0 6px 0 16px">是否登录小程序</span>
          <span>
            <el-radio-group
              v-model="login_applet"
              @change="search(1)"
            >
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            :data="extraData"
            tooltip-effect="dark"
            style="width: 100%;"
            height="500px"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column
              prop="nick_name"
              label="用户昵称（被邀请）"
              align="center"
            />
            <el-table-column
              prop="phone"
              label="手机号（被邀请）"
              align="center"
            />
            <el-table-column
              label="是否登录APP"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.item_id>0">是</span>
              </template>
            </el-table-column>
            <el-table-column
              label="是否有效邀请"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.is_effective==1">是</span>
                <span v-if="scope.row.is_effective==0">否</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nick_name: '',
      phone: '',
      recommender_code: '',
      recommender_name: '',
      cover_nick_name: '',
      cover_phone: '',
      is_staff: 0,
      is_effective: 0,
      login_applet: 0,
      login_app: 0,
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      extraShow: false,
      extraData: [],
      is_effective_m: 0,
      user_id: ''
    };
  },
  activated() {
    this.getList();
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        nick_name: this.nick_name,
        phone: this.phone,
        recommender_code: this.recommender_code,
        recommender_name: this.recommender_name,
        cover_nick_name: this.cover_nick_name,
        cover_phone: this.cover_phone,
        is_staff: this.is_staff,
        login_app: this.login_app,
        is_effective: this.is_effective,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios.post('platform/Activity/getPullNewList', data).then((res) => {
        this.totalNum = res.data.total;
        this.fomartList(res.data.list);
      });
    },
    search(type) {
      if (type) {
        this.showMore();
      } else {
        this.currentPage = 1;
        this.getList();
      }
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //格式化获取的推荐人列表
    fomartList(list) {
      let arr = [];
      list.forEach((ele) => {
        if (ele.item_list.length > 0) {
          let children = [];
          ele.item_list.forEach((docInfo, index) => {
            let obj = {
              user_id: ele.user_id,
              nick_name: ele.nick_name,
              phone: ele.phone,
              recommender_code: ele.recommender_code,
              recommender_name: ele.recommender_name,
              user_id_m: docInfo.user_id,
              nick_name_m: docInfo.nick_name,
              phone_m: docInfo.phone,
              item_id: docInfo.item_id,
              is_effective: docInfo.is_effective,
              openid: docInfo.openid
            };
            if (index <= 9) {
              arr.push(obj);
              children.push(obj);
            } else {
              children.push(obj);
            }
          });
          if (ele.share_count > 10) {
            let obj = {
              user_id: ele.user_id,
              nick_name: ele.nick_name,
              phone: ele.phone,
              recommender_code: ele.recommender_code,
              recommender_name: ele.recommender_name,
              phone_m: '查看更多',
              children: children
            };
            arr.push(obj);
          }
        } else {
          ele.user_id_m = '';
          ele.nick_name_m = '';
          ele.phone_m = '';
          ele.item_id = 0;
          ele.openid = '';
          ele.is_effective = '';
          arr.push(ele);
        }
      });
      this.tableData = arr;
    },
    //合并表格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let num = 0;
      if (
        columnIndex == 0 ||
        columnIndex == 1 ||
        columnIndex == 2 ||
        columnIndex == 3 ||
        columnIndex == 9
      ) {
        this.tableData.forEach((ele) => {
          if (row.user_id == ele.user_id) {
            num++;
          }
        });
      }
      if (num == 1) {
        return {
          rowspan: 1,
          colspan: 1
        };
      } else if (num > 1) {
        if (
          this.tableData[rowIndex - 1] &&
          this.tableData[rowIndex].user_id ==
            this.tableData[rowIndex - 1].user_id
        ) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          return {
            rowspan: num,
            colspan: 1
          };
        }
      }
    },
    //超过10个时查看更多
    showMore(user_id) {
      if (user_id) {
        this.user_id = user_id;
      }
      let data = {
        user_id: user_id ? user_id : this.user_id,
        is_effective: this.is_effective_m,
        login_applet: this.login_applet,
        page: 1,
        pageNumber: 10000
      };
      this.axios.post('platform/Activity/getPullMoreList', data).then((res) => {
        this.extraData = res.data.list;
        this.extraShow = true;
      });
    },
    toEditLog(user_id) {
      this.$router.push({
        path: 'editlog',
        query: {
          user_id: user_id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  margin-bottom: 10px;
  align-items: center;
  .box {
    margin-right: 20px;
    margin-bottom: 10px;
    align-items: center;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
    margin-left: 10px;
  }
}
</style>
<style lang="scss">
.border-column {
  border-left: 1px solid #ebeef5;
}
</style>


